import { TextScramble } from "./text-scramble";
import type React from "react";

interface ScrambledSectionTitleProps {
  children: React.ReactNode;
  speed?: number;
  revealRate?: number;
}

export function ScrambledSectionTitle({ children, speed = 70, revealRate = 0.04 }: ScrambledSectionTitleProps) {
  if (typeof children !== "string") {
    return <h2 className="text-5xl font-black tracking-tight">{children}.</h2>;
  }

  return (
    <h2 className="text-5xl font-black tracking-tight">
      <TextScramble text={`${children}.`} speed={speed} revealRate={revealRate} className="inline" />
    </h2>
  );
}
